// extracted by mini-css-extract-plugin
export default {"container":"InviteAcceptPage_container__skW9R","error":"InviteAcceptPage_error__ECIqL"};